module.exports = __webpack_public_path__ + "img/729-6ce2a7.png";